import { render, staticRenderFns } from "./xtMessage.vue?vue&type=template&id=a8233cd8&"
import script from "./xtMessage.vue?vue&type=script&lang=js&"
export * from "./xtMessage.vue?vue&type=script&lang=js&"
import style0 from "./xtMessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports